export const isEnglishLanguage = (language?: string): boolean => {
  return Boolean(language?.startsWith('en'));
};

const vehicleModelLabels: Record<string, string> = {
  베뉴: 'Venue',
  '제네시스 G80': 'Genesis G80',
  G80: 'Genesis G80',
  '테슬라Model Y': 'Tesla Model Y',
  '테슬라 Model Y': 'Tesla Model Y',
  'Model Y': 'Model Y',
  '볼트 EV': 'Bolt EV',
  '볼트(EV)': 'Bolt EV',
  아반떼: 'Avante',
  '아반떼 AD': 'Avante AD',
  '아반떼 CN7': 'Avante CN7',
  '아반떼 CN7 FL': 'Avante CN7 FL',
  K5: 'K5',
  '3세대 K5': '3rd Gen K5',
  소나타: 'Sonata',
  '소나타 DN8': 'Sonata DN8',
  쏘나타: 'Sonata',
  '쏘나타 디 엣지': 'Sonata The Edge',
  그랜저: 'Grandeur',
  그랜져: 'Grandeur',
  '그랜저 GN7': 'Grandeur GN7',
  '그랜져 GN7': 'Grandeur GN7',
  캐스퍼: 'Casper',
  레이: 'Ray',
  토레스: 'Torres',
  스포티지: 'Sportage',
  카니발: 'Carnival',
  '4세대 카니발': '4th Gen Carnival',
  '4세대카니발': '4th Gen Carnival',
  '카니발 리무진 7인승': 'Carnival Limousine 7-Seater',
  '카니발 리무진 4세대 7인승': '4th Gen Carnival Limousine 7-Seater',
  '카니발 리무진 4세대(7인승)': '4th Gen Carnival Limousine 7-Seater',
  '4세대 카니발 리무진': '4th Gen Carnival Limousine',
  '4세대카니발 리무진': '4th Gen Carnival Limousine',
  '4세대카니발리무진': '4th Gen Carnival Limousine',
  '카니발 9인승': 'Carnival 9-Seater',
  'All New 카니발 9인승': 'All New Carnival 9-Seater',
  'All New 카니발(9인승)': 'All New Carnival 9-Seater',
  'All New 카니발 4세대 9인승': 'All New 4th Gen Carnival 9-Seater',
  'All New 카니발 4세대(9인승)': 'All New 4th Gen Carnival 9-Seater',
  '카니발 리무진': 'Carnival Limousine',
  'All New 카니발 리무진': 'All New Carnival Limousine',
  그랜드스타렉스: 'Grand Starex',
  스타리아: 'Staria',
  '스타리아 9인승': 'Staria 9-Seater',
  '스타리아(9인승)': 'Staria 9-Seater',
  '스타리아 11인승': 'Staria 11-Seater',
  '스타리아(11인승)': 'Staria 11-Seater',
  스타렉스: 'Starex',
  쏠라티: 'Solati',
  셀토스: 'Seltos',
  쏘렌토: 'Sorento',
  '4세대 쏘렌토 FL': '4th Gen Sorento FL',
  '소렌토MQ4 FL': 'Sorento MQ4 FL',
  싼타페: 'Santa Fe',
  투싼: 'Tucson',
  올뉴투싼: 'All New Tucson',
  '올뉴 투싼': 'All New Tucson',
  팰리세이드: 'Palisade',
  '디 올뉴 펠리세이드': 'The All-New Palisade',
};

const carClassLabels: Record<string, string> = {
  경차: 'Compact',
  소형: 'Economy',
  준중형: 'Compact Sedan',
  중형: 'Midsize',
  준대형: 'Semi Full-size',
  대형: 'Full-size',
  수입: 'Imported',
  승합: 'Van',
  미니버스: 'Minibus',
  전기차: 'Electric',
  RV: 'RV',
  SUV: 'SUV',
};

const categoryCodeLabels: Record<string, string> = {
  compact: 'Compact',
  sedan: 'Compact Sedan',
  midsize: 'Midsize',
  fullsize: 'Full-size',
  suv: 'SUV',
  van: 'Van',
  minibus: 'Minibus',
  electric: 'Electric',
};

const fuelLabels: Record<string, string> = {
  가솔린: 'Gasoline',
  휘발유: 'Gasoline',
  gasoline: 'Gasoline',
  LPG: 'LPG',
  lpg: 'LPG',
  디젤: 'Diesel',
  경유: 'Diesel',
  diesel: 'Diesel',
  전기: 'Electric',
  electric: 'Electric',
  하이브리드: 'Hybrid',
  hybrid: 'Hybrid',
};

const companyLabels: Record<string, string> = {
  현대: 'Hyundai',
  기아: 'Kia',
  테슬라: 'Tesla',
  제네시스: 'Genesis',
  쉐보레: 'Chevrolet',
  르노: 'Renault',
  쌍용: 'KG Mobility',
  KG모빌리티: 'KG Mobility',
};

const optionLabels: Record<string, string> = {
  네비게이션: 'Navigation',
  네비: 'Navigation',
  블랙박스: 'Dashcam',
  하이패스: 'Hi-pass',
  블루투스: 'Bluetooth',
  열선시트: 'Heated Seats',
  '휴대폰 무선 충전': 'Wireless Phone Charging',
  '무선 충전': 'Wireless Charging',
  '카시트(영유아용) 1개': 'Infant Car Seat x 1',
  '카시트(영유아용) 2개': 'Infant Car Seat x 2',
  '카시트(주니어용) 1개': 'Junior Car Seat x 1',
  '카시트(주니어용) 2개': 'Junior Car Seat x 2',
  '카시트 영유아용 1개': 'Infant Car Seat x 1',
  '카시트 영유아용 2개': 'Infant Car Seat x 2',
  '카시트 주니어용 1개': 'Junior Car Seat x 1',
  '카시트 주니어용 2개': 'Junior Car Seat x 2',
  카시트: 'Car Seat',
  영유아용: 'Infant',
  주니어용: 'Junior',
  코일메트: 'Coil Mats',
  코일매트: 'Coil Mats',
};

const locationLabels: Record<string, string> = {
  본사: 'Main Office',
  서면: 'Seomyeon',
  가야: 'Gaya',
  '부산 부산진구 전포동 674-4': '674-4 Jeonpo-dong, Busanjin-gu, Busan',
  '부산 부산진구 서전로 42': '42 Seojeon-ro, Busanjin-gu, Busan',
  '부산시 부산진구 가야동 58-1': '58-1 Gaya-dong, Busanjin-gu, Busan',
  '부산 부산진구 가야동 58-1': '58-1 Gaya-dong, Busanjin-gu, Busan',
};

export const localizeVehicleModel = (modelName?: string, language?: string): string => {
  if (!modelName || !isEnglishLanguage(language)) return modelName || '';
  if (vehicleModelLabels[modelName]) return vehicleModelLabels[modelName];

  return Object.entries(vehicleModelLabels)
    .reduce(
      (label, [korean, english]) => label.replaceAll(korean, english),
      modelName.replace('테슬라Model', 'Tesla Model')
    )
    .replaceAll('디 올뉴', 'The All-New')
    .replaceAll('올뉴', 'All New')
    .replaceAll('3세대', '3rd Gen')
    .replaceAll('4세대', '4th Gen')
    .replace(/(\d+)인승/g, '$1-Seater');
};

export const localizeCarClass = (carClass?: string, language?: string): string => {
  if (!carClass || !isEnglishLanguage(language)) return carClass || '';
  return carClassLabels[carClass] || categoryCodeLabels[carClass.toLowerCase()] || carClass;
};

export const localizeFuel = (fuel?: string, language?: string): string => {
  if (!fuel || !isEnglishLanguage(language)) return fuel || '';
  return fuelLabels[fuel] || fuelLabels[fuel.toLowerCase()] || fuel;
};

export const localizeCompany = (company?: string, language?: string): string => {
  if (!company || !isEnglishLanguage(language)) return company || '';
  return companyLabels[company] || company;
};

export const localizeOption = (option?: string, language?: string): string => {
  if (!option || !isEnglishLanguage(language)) return option || '';
  return (optionLabels[option] || Object.entries(optionLabels).reduce(
    (label, [korean, english]) => label.replaceAll(korean, english),
    option
  ))
    .replace(/(\d+)개/g, 'x $1')
    .replaceAll('(', ' (')
    .replace(/\s+/g, ' ')
    .trim();
};

export const localizeSeatLabel = (seatLabel?: string, language?: string): string => {
  if (!seatLabel || !isEnglishLanguage(language)) return seatLabel || '';
  return seatLabel.replace(/(\d+)인/g, '$1 seats').replace(/(\d+)명/g, '$1 people');
};

export const localizeLocation = (location?: string, language?: string): string => {
  if (!location || !isEnglishLanguage(language)) return location || '';

  return Object.entries(locationLabels)
    .reduce((label, [korean, english]) => label.replaceAll(korean, english), location)
    .replaceAll('부산시', 'Busan')
    .replaceAll('부산', 'Busan')
    .replaceAll('부산진구', 'Busanjin-gu')
    .replaceAll('전포동', 'Jeonpo-dong')
    .replaceAll('가야동', 'Gaya-dong')
    .replaceAll('서전로', 'Seojeon-ro');
};
